export function stageThemeVisuals(themeData, { accentFallback = '#6845d3' } = {}) {
  const t = themeData || {};
  const textColor =
    (t.text_color != null && String(t.text_color).trim()) || '#1e2a4a';
  const buttonBgColor =
    (t.button_background_color != null && String(t.button_background_color).trim()) ||
    (t.box_bg_color != null && String(t.box_bg_color).trim()) ||
    accentFallback;
  const buttonTextColor =
    (t.button_text_color != null && String(t.button_text_color).trim()) ||
    '#ffffff';
  const boxTextColor =
    (t.box_text_color != null && String(t.box_text_color).trim()) ||
    '#000000';
  return { textColor, buttonBgColor, buttonTextColor, boxTextColor };
}

export function buildStagePageStyle(visuals, stagePrefix) {
  return {
    [`--${stagePrefix}-text`]: visuals.textColor,
    [`--${stagePrefix}-accent`]: visuals.buttonBgColor,
    [`--${stagePrefix}-btn-text`]: visuals.buttonTextColor,
    [`--${stagePrefix}-box-text`]: visuals.boxTextColor,
    '--stage-box-text': visuals.boxTextColor,
  };
}
